var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('footer', {
    staticClass: "footer-agreement"
  }, [_c('div', {
    staticClass: "logo-footer"
  }), _c('div', {
    staticClass: "agreement-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.agreement,
      expression: "agreement"
    }],
    attrs: {
      "type": "checkbox",
      "id": "agreement"
    },
    domProps: {
      "checked": Array.isArray(_vm.agreement) ? _vm._i(_vm.agreement, null) > -1 : _vm.agreement
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.agreement,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.agreement = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.agreement = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.agreement = $$c;
        }
      }
    }
  }), _vm._m(0)])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticClass: "agreement",
    attrs: {
      "for": "agreement"
    }
  }, [_vm._v(" Нажимая на кнопку “Продолжить” Вы принимаете "), _c('a', {
    attrs: {
      "href": "/privacy",
      "target": "_blank"
    }
  }, [_vm._v("Условия использования сервиса “Финсайт”")]), _vm._v(", даете "), _c('a', {
    attrs: {
      "href": "/privacy",
      "target": "_blank"
    }
  }, [_vm._v("согласие на обработку своих персональных данных и соглашаетесь с условиями политики конфиденциальности")])]);
}]

export { render, staticRenderFns }